import classNames from 'classnames'
import React from 'react'
import { IconFa } from '../icon-fa'
import { PlainButton } from '../plain-button'

export const BackButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <PlainButton
    type="button"
    {...props}
    className={classNames(props.className, 'text-emphasis-high font-semibold text-lg')}
  >
    <IconFa icon={['far', 'chevron-left']} className="mx-1" />
  </PlainButton>
)
